import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
import { Input } from './Input';
import { Select } from './Select';
import { RichTextEditor } from './RichTextEditor';
interface AddEarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (earning: {
    amount: number;
    date: string;
    type: 'Ladeboks' | 'Andet';
    customerId?: string;
    customerName?: string;
    notes?: string;
  }) => void;
  customers: Array<{
    id: string;
    customerId: string;
    name: string;
  }>;
}
export function AddEarningModal({
  isOpen,
  onClose,
  onAdd,
  customers
}: AddEarningModalProps) {
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [type, setType] = useState<'Ladeboks' | 'Andet'>('Ladeboks');
  const [customerId, setCustomerId] = useState('');
  const [notes, setNotes] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!amount) return;
    const customer = customers.find(c => c.id === customerId);
    onAdd({
      amount: parseFloat(amount),
      date,
      type,
      customerId: customerId || undefined,
      customerName: customer?.name || undefined,
      notes: notes || undefined
    });
    // Reset form
    setAmount('');
    setDate(new Date().toISOString().split('T')[0]);
    setType('Ladeboks');
    setCustomerId('');
    setNotes('');
    onClose();
  };
  return <AnimatePresence data-id="element-55" data-mp="1olo0b6g3hb1a">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-56" data-mp="1on8rcm37abue" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        duration: 0.3
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto" data-id="element-57" data-mp="27cffiomrjvnl">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 my-8" data-id="element-58" data-mp="1yb381lzhj0go">
              <div className="flex items-center justify-between mb-6" data-id="element-59" data-mp="1tgz0b0ieaoej">
                <h2 className="text-2xl font-semibold text-stone-900" data-id="element-60" data-mp="1ok8k8d6lbst4">
                  Tilføj indtjening
                </h2>
                <button onClick={onClose} className="text-stone-400 hover:text-stone-600 transition-colors" aria-label="Luk" data-id="element-61" data-mp="1kjgalitt3lwb">
                  <XIcon className="w-6 h-6" data-id="element-62" data-mp="1ak7kj122arf8" />
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-63" data-mp="3m69ev6ohz37d">
                <Input label="Beløb (kr)" type="number" step="0.01" value={amount} onChange={e => setAmount(e.target.value)} placeholder="f.eks. 8000" required data-id="element-64" data-mp="3r52tj2fit094" />

                <Input label="Dato" type="date" value={date} onChange={e => setDate(e.target.value)} required data-id="element-65" data-mp="33hclr64u6gqq" />

                <Select label="Type" value={type} onChange={e => setType(e.target.value as 'Ladeboks' | 'Andet')} options={[{
              value: 'Ladeboks',
              label: 'Ladeboks'
            }, {
              value: 'Andet',
              label: 'Andet'
            }]} required data-id="element-66" data-mp="3cfeuk7utadok" />

                <Select label="Kunde (valgfri)" value={customerId} onChange={e => setCustomerId(e.target.value)} options={[{
              value: '',
              label: 'Ingen kunde'
            }, ...customers.map(c => ({
              value: c.id,
              label: `${c.name} (${c.customerId})`
            }))]} data-id="element-67" data-mp="2fcbptoctthx4" />

                <RichTextEditor label="Noter" value={notes} onChange={setNotes} placeholder="Tilføj noter om denne indtjening" rows={3} data-id="element-68" data-mp="2tdeca27qgu8k" />

                <div className="flex gap-3 pt-2" data-id="element-69" data-mp="z0ogfext1ayj">
                  <Button type="button" variant="secondary" onClick={onClose} className="flex-1" data-id="element-70" data-mp="3amqd3r7ppytu">
                    Annuller
                  </Button>
                  <Button type="submit" variant="primary" className="flex-1" data-id="element-71" data-mp="30u1bdo1yrzbp">
                    Tilføj indtjening
                  </Button>
                </div>
              </form>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}